export const enum LinkType {
    none = "",
    checklist = "checklist",
    audit = "audit"
}


// WEBPACK FOOTER //
// ./src/Models/Tasks/LinkType.tsx